import React from "react";
import { Link } from "react-router-dom";
import './Home.css';

export default function Home(props) {
  return (
    <div className={` ${props.mode}`}>
      <div className="homeContainer">
        <div className="decorative-element top-left">
          <img src="https://cdni.iconscout.com/illustration/premium/thumb/quiz-timer-illustration-download-in-svg-png-gif-file-formats--answer-game-fast-question-quick-suspicious-various-theme-set-017-pack-business-illustrations-6382469.png?f=webp" alt="Icon" />
        </div>

        <div className="decorative-element top-right">
          <img src="https://cdni.iconscout.com/illustration/premium/thumb/man-participating-in-a-quiz-competition-7365569-6035425.png?f=webp" alt="Icon" />
        </div>

        <div className="heading homeheading">
          <div className="hometitle">
            <h1>QUIZ <span>MASTER</span></h1>
          </div>
          <p>"Don't Waste Your Time, Invest Your Time"</p>
          <p>Challenge your mind and expand your knowledge with fun quizzes!</p>
        </div>

        <div className="mainHomeContainer">
          <div className="container">
            <h1>Coding</h1>
            <p className="category-description">Sharpen your programming skills with these coding challenges:</p>
            <Link className="btn" to="/html"><button>HTML</button></Link>
            <Link className="btn" to="/css"><button>CSS</button></Link>
            <Link className="btn" to="/js"><button>JAVASCRIPT</button></Link>
            <Link className="btn" to="/java"><button>JAVA</button></Link>
            <Link className="btn" to="/mysql"><button>MySQL</button></Link>
            <Link className="btn" to="/cpp"><button>CPP</button></Link>
            <p className="cta">Ready to code your way to success?</p>
          </div>
          <div className="container">
            <h1>Aptitude</h1>
            <p className="category-description">Enhance your problem-solving abilities with these aptitude tests:</p>
            <Link className="btn" to="/trainProblem"><button>TRAIN PROBLEMS</button></Link>
            <Link className="btn" to="/percentage"><button>PERCENTAGE</button></Link>
            <Link className="btn" to="/averages"><button>AVERAGES</button></Link>
            <Link className="btn" to="/codingDecoding"><button>CODING DECODING</button></Link>
            <Link className="btn" to="/missingTerm"><button>MISSING TERM</button></Link>
            <Link className="btn" to="/calender"><button>CALENDAR</button></Link>
            <p className="cta">Think fast, solve faster!</p>
          </div>
          <div className="container">
            <h1>General Knowledge</h1>
            <p className="category-description">Boost your knowledge about the world with our GK quizzes:</p>
            <Link className="btn" to="/History"><button>HISTORY</button></Link>
            <Link className="btn" to="/Geography"><button>GEOGRAPHY</button></Link>
            <Link className="btn" to="/IndianPolitics"><button>INDIAN POLITICS</button></Link>
            <Link className="btn" to="/currentAffairs"><button>CURRENT AFFAIRS</button></Link>
            <Link className="btn" to="/worldWars"><button>WORLD WARS</button></Link>
            <Link className="btn" to="/Marathi"><button>MARATHI</button></Link>
            <p className="cta">Know more, achieve more!</p>
          </div>
        </div>
      </div>
    </div>
  );
}
